import { ColumnDef } from "@tanstack/react-table"

import { ServiceRequestHistoryType } from "@/types/service-request-history"
import { formatDateAndTime } from "@/lib/utils"

import { DataTableColumnHeader } from "../../data-table"

export const serviceRequestHistoryColumns: ColumnDef<ServiceRequestHistoryType>[] =
  [
    {
      accessorKey: "service_request_num",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Service Request #" />
      ),
      cell: ({ row }) => <div>{row.original.service_request_num}</div>,
    },
    {
      accessorKey: "created_at",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Date Requested" />
      ),
      cell: ({ row }) => (
        <div>{formatDateAndTime(row.original.created_at)}</div>
      ),
    },
    {
      accessorKey: "consumer_name",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Consumer" />
      ),
      cell: ({ row }) => <div>{row.original.consumer_name}</div>,
    },
    {
      accessorKey: "initial_reading",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Initial Reading" />
      ),
      cell: ({ row }) => <div>{row.original.initial_reading}</div>,
    },
    {
      accessorKey: "last_reading",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Last Reading" />
      ),
      cell: ({ row }) => <div>{row.original.last_reading}</div>,
    },
    {
      accessorKey: "requested_by",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Requested By" />
      ),
      cell: ({ row }) => <div>{row.original.requested_by}</div>,
    },
    {
      accessorKey: "complaint",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Complaint" />
      ),
      cell: ({ row }) => <div>{row.original.complaint}</div>,
    },
    {
      accessorKey: "action_required",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Action Required" />
      ),
      cell: ({ row }) => <div>{row.original.action_required}</div>,
    },
    {
      accessorKey: "remarks",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Remarks" />
      ),
      cell: ({ row }) => <div>{row.original.remarks}</div>,
    },
    {
      accessorKey: "prepared_by",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Prepared By" />
      ),
      cell: ({ row }) => <div>{row.original.prepared_by}</div>,
    },
    {
      accessorKey: "approved_by",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Approved By" />
      ),
      cell: ({ row }) => <div>{row.original.approved_by}</div>,
    },
  ]
